import { bus, ConnectingMessage, ConnectionAcceptedMessage } from './messageBus';

const ACKNOWLEDGEMENT_TIMEOUT = 1000;

export let isPrimaryInstance = false;

export function bootstrap(
  environment: string,
  quoteId: string | null,
  rfqId: string | null,
  onPrimary: (environment: string) => void,
  onDuplicate: (environment: string) => void,
  onQuoteOpened: (quoteId: string) => void,
  openRfqOpened: (rfqId: string) => void,
) {
  const timeoutId = setTimeout(() => {
    isPrimaryInstance = true;
  }, ACKNOWLEDGEMENT_TIMEOUT);
  onPrimary(environment);

  // Send a Connecting message the bus.
  bus.postMessage(new ConnectingMessage(environment, quoteId, rfqId));

  // Listen for messages on the bus.
  bus.onMessage(message => {
    if (message.environment === environment) {
      switch (message.type) {
        case 'CONNECTING':
          {
            bus.postMessage(new ConnectionAcceptedMessage(environment));
            if (message.quoteId !== null) {
              onQuoteOpened(message.quoteId);
            }
            if (message.rfqId !== null) {
              openRfqOpened(message.rfqId);
            }
          }
          break;
        case 'CONNECTED': {
          if (!isPrimaryInstance) {
            clearTimeout(timeoutId);
            bus.close();
            if (quoteId !== null || rfqId !== null) {
              onDuplicate(environment);
            }
          }
        }
      }
    }
  });
}
